import React, { useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import Select from 'react-select';
import { useFormik } from "formik";

import { Enumeration } from "../../utils/interface";
import { formatEnumsForDropDown } from "../../utils/helperFunction";

interface NewPropertyContentModalFormProps {
  propertyContentTypes: Enumeration[];
  PropertyContentValidationSchema: any;
  onAddPropertyContent: (propertyContent: any) => void;
}

const NewPropertyContentModalForm: React.FC<NewPropertyContentModalFormProps> = ({
  propertyContentTypes,
  PropertyContentValidationSchema,
  onAddPropertyContent,
}) => {
  const [showModal, setShowModal] = useState(false);

  const formattedOptions = formatEnumsForDropDown(propertyContentTypes);
  const defaultOption = formattedOptions.find(o => o.label?.toLowerCase().includes('thumbnail')) || formattedOptions[0];

  const handleModalClose = () => setShowModal(false);
  const handleModalOpen = () => {
    if (defaultOption && !formik.values.propertyContentTypeEnumId) {
      formik.setFieldValue('propertyContentTypeEnumId', defaultOption.value);
    }
    setShowModal(true);
  };

  const formik = useFormik({
    initialValues: {
      propertyContentTypeEnumId: defaultOption ? defaultOption.value : 4,
      contentFiles: [],
    },
    validationSchema: PropertyContentValidationSchema,
    onSubmit: (values, { resetForm }) => {
      onAddPropertyContent({
        ...values,
        propertyContentTypeEnumId: values.propertyContentTypeEnumId || defaultOption?.value || 4
      });
      resetForm();
      handleModalClose();
    },
  });

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const files = event.currentTarget.files;
    if (files) {
      formik.setFieldValue('contentFiles', Array.from(files));
    }
  };

  const selectedValue = formattedOptions.find(o => o.value === formik.values.propertyContentTypeEnumId) || defaultOption;

  return (<>
    <Button variant="primary" className="mb-3" onClick={handleModalOpen}>
      Upload Image
    </Button>
    <Modal show={showModal} onHide={handleModalClose}>
      <Modal.Header closeButton>
        <Modal.Title>Upload Image</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group className="mb-3" controlId="content-type">
            <Form.Label>Image Type</Form.Label>
            <Select
              options={formattedOptions}
              value={selectedValue}
              isSearchable
              placeholder="Select Image Type"
              onChange={(selectedOption) => {
                if (selectedOption) {
                  formik.setFieldValue('propertyContentTypeEnumId', selectedOption.value)
                }
              }}
            />
            {formik.touched.propertyContentTypeEnumId && formik.errors.propertyContentTypeEnumId ? (
              <Form.Text className="text-danger">
                {formik.errors.propertyContentTypeEnumId}
              </Form.Text>
            ) : null}
          </Form.Group>
          <Form.Group className="mb-3" controlId="content-file">
            <Form.Label>Image File</Form.Label>
            <Form.Control
              type="file"
              name="contentFiles"
              onChange={handleFileChange}
              multiple
            />
            {formik.touched.contentFiles && formik.errors.contentFiles ? (
              <Form.Text className="text-danger">
                {formik.errors.contentFiles}
              </Form.Text>
            ) : null}
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
          <Button variant="secondary" onClick={handleModalClose}>Close</Button>
          <Button variant="primary" onClick={() => formik.handleSubmit()}>Add</Button>
        </Modal.Footer>
    </Modal>
  </>);
};

export default NewPropertyContentModalForm;
